import { CIcon } from '~/icons/types'

export const ciInstagram: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.05 12V9a14.593 14.593 0 0 0-.3-3.6 5.64 5.64 0 0 0-5.5-4.4c-1.8 0-3.5-.1-5.3-.1-1.8 0-3.5 0-5.3.1a7.2 7.2 0 0 0-3.5 1.4 5.3 5.3 0 0 0-1.9 3.1A14.2 14.2 0 0 0 .95 9v6a14.6 14.6 0 0 0 .3 3.6 5.64 5.64 0 0 0 5.5 4.4c1.8.1 3.5.1 5.3.1 1.8 0 3.5 0 5.3-.1a6.86 6.86 0 0 0 3.6-1.3 5.3 5.3 0 0 0 1.9-3.1c.1-1.3.1-2.5.1-3.6 0-1 .1-2 .1-3Z',
      fill: 'url(#85728cbe-396c-4433-8952-5593612f4074-__b)'
    },
    {
      d:
        'M23.05 12V9a14.593 14.593 0 0 0-.3-3.6 5.64 5.64 0 0 0-5.5-4.4c-1.8 0-3.5-.1-5.3-.1-1.8 0-3.5 0-5.3.1a7.2 7.2 0 0 0-3.5 1.4 5.3 5.3 0 0 0-1.9 3.1A14.2 14.2 0 0 0 .95 9v6a14.6 14.6 0 0 0 .3 3.6 5.64 5.64 0 0 0 5.5 4.4c1.8.1 3.5.1 5.3.1 1.8 0 3.5 0 5.3-.1a6.86 6.86 0 0 0 3.6-1.3 5.3 5.3 0 0 0 1.9-3.1c.1-1.3.1-2.5.1-3.6 0-1 .1-2 .1-3Z',
      fill: 'url(#85728cbe-396c-4433-8952-5593612f4074-__c)'
    },
    {
      d:
        'M11.95 6.1a5.932 5.932 0 1 0 4.162 1.738A5.9 5.9 0 0 0 11.95 6.1Zm-.1 9.8A3.898 3.898 0 0 1 8 11.95a3.9 3.9 0 0 1 3.95-3.85 3.76 3.76 0 0 1 3.8 3.9 3.9 3.9 0 0 1-3.9 3.9Zm8-10.2a1.4 1.4 0 1 1-2.8 0 1.36 1.36 0 0 1 .86-1.3 1.4 1.4 0 0 1 .54-.1 1.43 1.43 0 0 1 1.4 1.4Z',
      fill: '#fff'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'instagram',
  type: 'solid',
  defs:
    '<radialGradient id="85728cbe-396c-4433-8952-5593612f4074-__b" cx="0" cy="0" r="1" gradientTransform="matrix(0 -21.927 20.393 0 6.764 24.751)" gradientUnits="userSpaceOnUse"><stop stop-color="#FD5"></stop><stop offset=".1" stop-color="#FD5"></stop><stop offset=".5" stop-color="#FF543E"></stop><stop offset="1" stop-color="#C837AB"></stop></radialGradient>,<radialGradient id="85728cbe-396c-4433-8952-5593612f4074-__c" cx="0" cy="0" r="1" gradientTransform="matrix(1.924 9.611 -39.61492 7.93037 -2.813 2.537)" gradientUnits="userSpaceOnUse"><stop stop-color="#3771C8"></stop><stop offset=".128" stop-color="#3771C8"></stop><stop offset="1" stop-color="#60F" stop-opacity="0"></stop></radialGradient>,<clipPath id="85728cbe-396c-4433-8952-5593612f4074-__a"><path fill="#fff" d="M0 0h24v24H0z"></path></clipPath>'
}
